import {
    AnonymizationRule,
    extendAnonymizationRule,
} from './anonymization_rule';

export const cloneMetaAnonymizationRule =
    (): MetainformationAnonymizationRule => {
        const jsonString = JSON.stringify(this);
        return JSON.parse(jsonString) as MetainformationAnonymizationRule;
    };

export const extendMetaAnonymizationRule = (
    self: MetainformationAnonymizationRule,
    rule?: MetainformationAnonymizationRule
) => {
    if (!rule) {
        return self;
    }

    self = extendAnonymizationRule(self, rule);

    if (!self.metainformation) {
        self.metainformation = rule.metainformation;
    } else {
        self.metainformation = extendAnonymizationRule(
            self.metainformation,
            rule.metainformation
        );
    }

    return self;
};

export interface MetainformationAnonymizationRule extends AnonymizationRule {
    metainformation?: AnonymizationRule;
}
